import React, { useContext } from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import { StepContext, HorizontalStepContext } from 'components/StepForm';

import Styled from './styles';

export interface StepIndicatorProps {
  /** The contents of the indicator. Usually a number. */
  children?: string | number;
  /** The variant for styling purposes. The variant from  the `Step` or `HorizontalStep` component is used if this one is not set. */
  variant?: 'current' | 'future';
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** `StepIndicator`, all other props will be provided to the root component.` */
const StepIndicator = React.forwardRef<HTMLElement, StepIndicatorProps>((props: StepIndicatorProps, ref) => getContext(({ theme }) => {
  const {
    children,
    theme: themeProp,
    variant,
    ...otherProps
  } = props;
  const stepContext = useContext(StepContext);
  const horizontalStepContext = useContext(HorizontalStepContext);
  const resolvedTheme = _merge({}, theme.STEP_FORM, themeProp.STEP_FORM || themeProp);

  const isDisabled = stepContext.disabled || horizontalStepContext.disabled;
  return (
    <Styled.StepIndicator
      ref={ref}
      $theme={resolvedTheme}
      $variant={variant || stepContext.variant || horizontalStepContext.variant}
      disabled={isDisabled}
      {...otherProps}
    >
      <Styled.StepIndicatorInside>
        {children}
      </Styled.StepIndicatorInside>
    </Styled.StepIndicator>
  );
}));

StepIndicator.defaultProps = {
  children: undefined,
  variant: undefined,
  theme: {},
};

StepIndicator.displayName = 'StepIndicator';

export default StepIndicator;